query getGraphTimeseries(
    $clientId: ID
    $projectId: ID
    $productIds: [ID]
    $startDate: AWSDateTime
    $endDate: AWSDateTime
    $binSize: Int!
  ) {
    timeSeriesTotals: SalesAnalyticsGetTimeSeries(
      startDate: $startDate
      endDate: $endDate
      clientId: $clientId
      projectId: $projectId
      productIds: $productIds
      binSize: $binSize
      productView: BUNDLE
    ) {
      quantity
      timestamp
      sales
    }
  }